import * as React from 'react';

import { reportSentryError } from 'sentry';

type Props = {
  children: React.ReactNode;
};

type State = {
  error: Error | null;
};

export abstract class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  public componentDidCatch(
    error: Error,
    { componentStack }: React.ErrorInfo
  ): void {
    // componentDidCatch is used over getDerivedStateFromError
    // so that componentStack is accessible through state.
    reportSentryError(error, {
      level: 'fatal',
      extra: { componentStack }
    });
    this.setState({ error });
  }

  public render(): React.ReactNode {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return <div>Something went wrong.</div>;
    }

    if (typeof children === 'function') {
      return children();
    }

    return children;
  }
}
